import { usePwaUpdate } from "@/hooks/usePwaUpdate";
import { RefreshCw } from "lucide-react";

/**
 * Banner global fixo exibido no topo quando há nova versão do PWA disponível.
 * Fica visível em todas as rotas para reduzir a lentidão percebida após publicar
 * (o usuário atualiza imediatamente em vez de aguardar o SW ativar sozinho).
 */
export default function PwaUpdateBanner() {
  const { needsUpdate, update, version } = usePwaUpdate();

  if (!needsUpdate) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed top-0 inset-x-0 z-[9999] px-3 pt-[env(safe-area-inset-top)]"
    >
      <div className="mx-auto max-w-[520px] mt-2 rounded-2xl bg-amber-500/95 backdrop-blur shadow-lg border border-amber-400/40 flex items-center gap-3 p-3">
        {/* Texto escuro sobre âmbar: branco puro cai pra ~2.2:1 de contraste
            (reprova WCAG AA) nesse amarelo claro, em qualquer tema. */}
        <div className="w-9 h-9 rounded-full bg-amber-950/15 flex items-center justify-center shrink-0">
          <RefreshCw className="w-5 h-5 text-amber-950" />
        </div>
        <div className="flex-1 min-w-0 text-left">
          <p className="font-body font-semibold text-amber-950 text-sm leading-tight">
            Nova versão disponível
          </p>
          <p className="text-[11px] font-body text-amber-950/80 truncate">
            Atualize agora para melhor desempenho · v{version}
          </p>
        </div>
        <button
          onClick={update}
          className="shrink-0 px-3 py-2 rounded-xl bg-white text-amber-800 font-body font-semibold text-sm hover:bg-white/90 transition-colors"
        >
          Atualizar agora
        </button>
      </div>
    </div>
  );
}
